export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    back: 'Back',
    home: 'Home',
    language: 'Language',
    refresh: 'Refresh',
    viewAll: 'View All',
    viewDetailedReport: 'View Detailed Report',
    noData: 'No data',
    undefined: 'Undefined',
    success: 'successful',
    actions: {
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      add: 'Add',
      update: 'Update',
      label: 'Actions'
    },
    pagination: {
      total: 'Total',
      page: 'Page',
      perPage: 'Per page'
    },
    filters: {
      apply: 'Apply',
      reset: 'Reset',
      advanced: 'Advanced filters',
      active: 'Active filters:',
      columnDisplay: 'Customize columns',
      search: 'Search',
      from: 'From',
      to: 'To',
      all: 'All',
      selectYear: 'Select year',
      selectQuarter: 'Select quarter',
      currentYear: 'Current year',
      previousYear: 'Previous year',
      year: 'Year',
      quarter: 'Quarter',
      startDate: 'Start Date',
      endDate: 'End Date'
    }
  },
  menu: {
    dashboard: 'Dashboard',
    expenses: 'Expenses',
    categories: 'Categories',
    reports: 'Reports',
    accountHolders: 'Account Holders'
  },
  navbar: {
    profile: 'Profile',
    logout: 'Logout',
    settings: 'Settings'
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    email: 'Email',
    password: 'Password'
  },
  dashboard: {
    title: 'Dashboard',
    summary: 'Summary',
    expenses: 'Expenses',
    categories: 'Categories',
    reports: 'Reports',
    welcome: 'Welcome to LTV Cocktail',
    editor: {
      welcome: 'Welcome to Editor Dashboard'
    },
    guest: {
      welcome: 'Welcome to Guest Dashboard'
    },
    stats: {
      totalExpense: 'Total Expense',
      categories: 'Categories',
      expenseCount: 'Number of Expenses',
      accountHolders: 'Account Holders',
      total: 'Total'
    },
    chart: {
      quarterlyExpenses: 'Quarterly Expenses',
      year: 'Year',
      recentExpenses: 'Recent Expenses',
      noExpensesInMonth: 'No expenses in selected month',
      selectYear: 'Select year',
      selectMonth: 'Select month'
    },
    table: {
      paymentDate: 'Payment Date',
      expenseType: 'Expense Type',
      category: 'Category',
      description: 'Description',
      amount: 'Amount',
      accountHolder: 'Account Holder',
      actions: 'Actions'
    }
  },
  expenses: {
    title: 'Expense Management',
    actions: {
      add: 'Add Expense',
      edit: 'Edit Expense',
      delete: 'Delete',
      approve: 'Approve',
      reject: 'Reject',
      markAsPaid: 'Mark as Paid',
      import: 'Import'
    },
    form: {
      paymentDate: 'Payment Date',
      expenseType: 'Expense Type',
      category: 'Category',
      description: 'Description',
      amount: 'Amount',
      accountHolder: 'Account Holder',
      status: 'Status',
      accountNumber: 'Account Number',
      bankName: 'Bank Name',
      note: 'Note',
      document: 'Document',
      invoicePdf: 'Invoice PDF',
      invoiceXml: 'Invoice XML'
    },
    filters: {
      expenseType: 'Expense Type',
      category: 'Category',
      status: 'Status',
      accountHolder: 'Account Holder',
      accountNumber: 'Account Number',
      bankName: 'Bank Name',
      minAmount: 'Minimum Amount',
      maxAmount: 'Maximum Amount',
      note: 'Note',
      dateRange: 'Date Range',
      startDate: 'Start Date',
      endDate: 'End Date'
    },
    status: {
      approved: 'Approved',
      pending: 'Pending',
      paid: 'Paid',
      rejected: 'Rejected'
    },
    stats: {
      approved: 'Approved',
      pending: 'Pending',
      paid: 'Paid',
      rejected: 'Rejected',
      total: 'Total'
    },
    table: {
      paymentDate: 'Payment Date',
      expenseType: 'Expense Type',
      category: 'Category',
      description: 'Description',
      amount: 'Amount',
      accountHolder: 'Account Holder',
      accountNumber: 'Account Number',
      bankName: 'Bank Name',
      status: 'Status',
      note: 'Note',
      actions: 'Actions'
    },
    import: {
      processing: 'Processing data...',
      importing: 'Importing data...',
      confirmation: 'Confirm import of {count} expenses from Excel?',
      confirmTitle: 'Confirm Import',
      importButton: 'Import',
      success: 'Successfully imported {count} expenses',
      templateInfoTitle: 'Import Template Information',
      templateInstructions: 'The Excel file must have the following columns:',
      downloadQuestion: 'Do you want to download the Excel template?',
      downloadTemplate: 'Download Template',
      templateSheetName: 'Expense Import Template',
      templateFileName: 'expense_import_template.xlsx',
      fields: {
        paymentDate: 'Payment Date (format YYYY-MM-DD)',
        expenseType: 'Expense Type',
        category: 'Category',
        description: 'Description',
        amount: 'Amount',
        accountHolder: 'Account Holder',
        accountNumber: 'Account Number',
        bankName: 'Bank Name',
        status: 'Status (Pending, Approved, Paid, Rejected)',
        note: 'Note'
      },
      examples: {
        mealType: 'Business Meal',
        mealCategory: 'Dining',
        mealDesc: 'Lunch with ABC client',
        mealNote: 'Receipt attached',
        suppliesType: 'Office Supplies',
        suppliesCategory: 'Office Equipment',
        suppliesDesc: 'A4 paper, pens, and clips',
        suppliesNote: 'Purchased from Stationery Store',
        transportType: 'Transportation',
        transportCategory: 'Travel',
        transportDesc: 'Taxi to XYZ client meeting',
        transportNote: 'Taxi receipt included',
        utilityType: 'Utility',
        utilityCategory: 'Bills',
        utilityDesc: 'Office electricity bill May',
        utilityNote: 'Electronic invoice',
        person1: 'John Smith',
        person2: 'Mary Johnson',
        person3: 'David Lee',
        person4: 'Sarah Wilson'
      },
      errors: {
        cannotRead: 'Cannot read file',
        readError: 'Error reading Excel file',
        processingError: 'Error processing Excel file',
        missingHeaders: 'Missing required columns: {headers}',
        noData: 'No data to import',
        importError: 'Import error',
        excelImportError: 'Error importing data from Excel',
        rowError: 'Row {row}: {message}'
      }
    }
  },
  categories: {
    title: 'Categories',
    add: 'Add Category',
    edit: 'Edit Category',
    name: 'Name',
    description: 'Description',
    code: 'Category Code',
    codeHelpText: 'Code is up to 10 characters, must be unique',
    deleteConfirmation: 'Are you sure you want to delete this category?',
    deleteSuccess: 'Category deleted successfully',
    validation: {
      nameRequired: 'Category name is required',
      codeRequired: 'Category code is required',
      codeDuplicate: 'Category code already exists, please choose another code'
    }
  },
  reports: {
    title: 'Expense Report',
    overview: {
      title: 'Overview',
      totalExpense: 'Total Expense',
      quarterlyBreakdown: 'Quarterly Breakdown',
      yearlyBreakdown: 'Yearly Breakdown'
    },
    timeRange: {
      allYears: 'All Years',
      currentYear: 'Current Year',
      previousYear: 'Previous Year',
      year: 'Year {year}'
    },
    charts: {
      byTime: {
        title: 'Time Distribution',
        yearlyTitle: 'Total expenses by year',
        quarterlyTitle: 'Total expenses by quarter',
        selectYears: 'Select years (default: all)'
      },
      byType: {
        title: 'Expense Type Distribution',
        subtitle: 'Total expenses by expense type'
      },
      byCategory: {
        title: 'Category Distribution',
        subtitle: 'Total expenses by category'
      },
      byAccountHolder: {
        title: 'Account Holder Distribution',
        subtitle: 'Total expenses by account holder'
      },
      detailedExpenses: {
        title: 'Transaction Details',
        subtitle: 'Detailed expenses list'
      }
    },
    filters: {
      timeRange: 'Select time range',
      year: 'Select year',
      quarter: 'Select quarter',
      expenseType: 'Expense type',
      category: 'Category',
      accountHolder: 'Account Holder'
    },
    table: {
      year: 'Year',
      quarter: 'Quarter',
      totalAmount: 'Total Amount',
      expenseType: 'Expense Type',
      category: 'Category',
      accountHolder: 'Account Holder',
      paymentDate: 'Payment Date',
      description: 'Description',
      amount: 'Amount',
      status: 'Status'
    }
  },
  accountHolders: {
    title: 'Account Holders',
    add: 'Add Account Holder',
    edit: 'Edit Account Holder',
    name: 'Name',
    accountNumber: 'Account Number',
    bank: 'Bank',
    note: 'Note',
    expenseCount: 'Number of Expenses'
  },
  error: {
    notFound: 'Page not found',
    unauthorized: 'Unauthorized',
    serverError: 'Server error',
    backHome: 'Back to home',
    loadingRecentExpenses: 'Could not load recent expenses',
    loadingQuarterlyExpenses: 'Could not load quarterly expenses',
    loadingStats: 'Could not load statistics',
    futureYearWarning: 'Switched to current year as future data cannot be queried',
    refreshData: 'Could not refresh data',
    savingCategory: 'Error saving category',
    deletingCategory: 'Error deleting category',
    fetchingCategories: 'Could not load categories'
  },
  info: {
    refreshing: 'Refreshing data...',
    refreshSuccess: 'Data has been updated',
    dataLoaded: 'Data loaded successfully',
    periodSelected: 'Selected period'
  }
} 